import React, { useState, useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import PhoneInput from "./PhoneInput/PhoneInput.js";
import DateInput from "./DateInput/DateInput.js";

export default function Record() {
  const [formData, setFormData] = useState({
    fio: "",
    phone: "+7",
    date: "",
    type: "",
  });
  const [isDateValid, setIsDateValid] = useState(false);
  const [wasSubmitted, setWasSubmitted] = useState(false);
  const [message, setMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [popupStatus, setPopupStatus] = useState("idle"); // sending | success | error
  const [isSubmitting, setIsSubmitting] = useState(false);
  const recaptchaRef = useRef(null);

  const API_URL =
    process.env.NODE_ENV === "production"
      ? "https://api.urniidvi.ru"
      : "http://localhost:5000";

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setWasSubmitted(true);
    setMessage("");

    if (!isDateValid) {
      setMessage("Введите корректную дату приема в формате ДД.ММ.ГГГГ");
      return;
    }

    const phoneDigits = formData.phone.replace(/\D/g, "");
    if (phoneDigits.length < 11) {
      setMessage("Введите корректный номер телефона");
      return;
    }
    if (!formData.type) {
      setMessage("Выберите тип приема");
      return;
    }

    const recaptchaValue = recaptchaRef.current.getValue();
    if (!recaptchaValue) {
      setMessage("Подтвердите, что вы не робот");
      return;
    }

    // 🔒 блокируем кнопку
    setIsSubmitting(true);
    setShowPopup(true);
    setPopupStatus("sending");

    try {
      const res = await fetch(`${API_URL}/api/send-mail`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          fio: formData.fio,
          phone: formData.phone,
          date: formData.date,
          type: formData.type === "adult" ? "Взрослый прием" : "Детский прием",
          to_email: "urniidvi-online@mail.ru", // куда отправляем заявку
        }),
      });

      const data = await res.json();

      if (!res.ok) throw new Error(data.message || "Ошибка");

      setFormData({ fio: "", phone: "+7", date: "", type: "" });
      setWasSubmitted(false);
      recaptchaRef.current.reset();
      setPopupStatus("success");
    } catch (err) {
      console.error(err);
      setMessage(err.message);
      setPopupStatus("error");
    }
  };

  const handleClosePopup = () => {
    setShowPopup(false);
    setPopupStatus("idle");
    setIsSubmitting(false); // 🔓 разблокируем кнопку
  };

  return (
    <section id="record" className="record">
      <div className="employees__description record__description">
        <h2 className="employees__title record__title">Запишитесь на прием</h2>
        <p className="employees__text record__text">
          Оставьте свои контактные данные, и наш администратор свяжется с вами
        </p>
      </div>

      <form onSubmit={handleSubmit} className="record__input-box">
        <input
          className="record__input"
          type="text"
          name="fio"
          placeholder="ФИО"
          value={formData.fio}
          onChange={handleChange}
        />

        <PhoneInput
          className="record__input"
          name="phone"
          value={formData.phone}
          onChange={handleChange}
        />
        <DateInput
          className="record__input"
          name="date"
          value={formData.date}
          onChange={handleChange}
          onValidityChange={setIsDateValid}
        />

        <select
          className={`record__input ${
            wasSubmitted && !formData.type ? "invalid" : ""
          }`}
          name="type"
          value={formData.type}
          onChange={handleChange}
        >
          <option value="" disabled>
            Прием
          </option>
          <option value="adult">Взрослый прием</option>
          <option value="child">Детский прием</option>
        </select>

        <div style={{ margin: "10px 0" }}>
          <ReCAPTCHA
            sitekey="6LdGG7srAAAAAGK6wMRUdW1xdkSsS6areWMsJhsW"
            ref={recaptchaRef}
          />
        </div>

        {message && (
          <p className="record__message" style={{ color: "red" }}>
            {message}
          </p>
        )}

        <button
          type="submit"
          className="record__button"
          disabled={isSubmitting || showPopup} // 🔒 блок при отправке и при открытом попапе
        >
          {isSubmitting ? "Отправка..." : "Заказать звонок"}
        </button>
      </form>

      {showPopup && (
        <div className="popup__overlay">
          <div className="popup__content">
            {popupStatus === "sending" && (
              <>
                <h3 className="popup__title">Отправка...</h3>
                <p className="popup__text">Пожалуйста, подождите.</p>
              </>
            )}
            {popupStatus === "success" && (
              <>
                <h3 className="popup__title">Заявка отправлена!</h3>
                <p className="popup__text">
                  Наш администратор скоро свяжется с вами.
                </p>
              </>
            )}
            {popupStatus === "error" && (
              <>
                <h3 className="popup__title">Ошибка!</h3>
                <p className="popup__text">Не удалось отправить письмо.</p>
              </>
            )}
            <button className="record__button" onClick={handleClosePopup}>
              Закрыть
            </button>
          </div>
        </div>
      )}
    </section>
  );
}
